export default "__VITE_ASSET__b9c0bf96__"